import React from 'react';

import MoreItemsArrow from 'jsx/elements/buttons/MoreItemsArrow';
import Spinner from 'jsx/elements/spinner';
import Tooltip from 'jsx/elements/messages/Tooltip';
import Trash from 'jsx/elements/buttons/Trash';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import Warning from 'jsx/elements/messages/Warning';
import { parseDate } from 'utils/date';
import { splitSsn } from 'utils/strings';

import useIncrement from 'hooks/useIncrement';

export default function MonitoringWatchlistModalList({
  loading,
  customerList,
  canRemove,
  onRemove,
}) {
  const { t } = useLocale();
  const [count, increment] = useIncrement(customerList.length, 10, 10);
  const opacity = loading ? '0.2' : '1';

  return (
    <div className="table-wrap gutter-top text-left">
      <Tooltip id="trashTip" />
      {loading && <Spinner size="medium" center />}
      {!loading && customerList.length === 0 && (
        <Warning
          messageType="info"
          messageHeader={t('portfolioMonitoring_monitoringList_table_noRecords')}
        />
      )}
      {customerList.length > 0 && (
        <table className="table gray-border" style={{ opacity: opacity }}>
          <colgroup>
            <col width="15%" />
            <col width="40%" />
            <col width="15%" />
            <col width="20%" />
            {canRemove && <col width="10%" />}
          </colgroup>
          <thead className="gray-bg">
            <tr>
              <th>{t('portfolioMonitoring_monitoringList_table_header_regno')}</th>
              <th>{t('portfolioMonitoring_monitoringList_table_header_name')}</th>
              <th>{t('portfolioMonitoring_monitoringList_table_header_inserted')}</th>
              <th>{t('portfolioMonitoring_monitoringList_table_header_lastEvent')}</th>
              {canRemove && <th />}
            </tr>
          </thead>
          <tbody>
            {customerList.slice(0, count).map((c, index) => {
              const click = () => onRemove(c.regno);
              const dateCheck = new Date(c.lastNotification);
              const lastNot = dateCheck.getYear() > 0 ? parseDate(c.lastNotification) : '-';
              return (
                <tr key={index}>
                  <td>{splitSsn(c.regno) || '-'}</td>
                  <td>{c.name || '-'}</td>
                  <td>{parseDate(c.inserted) || '-'}</td>
                  <td>{lastNot}</td>
                  {canRemove && (
                    <td>
                      <span
                        data-for="trashTip"
                        data-tip={t('portfolioMonitoring_monitoringList_table_remove_tooltip')}
                      >
                        <Trash onClick={click} />
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {count < customerList.length && (
        <div className="half-spacing-top">
          <MoreItemsArrow onClick={increment} />
        </div>
      )}
    </div>
  );
}
